import AppShell from "./AppShell";
import { getApp } from "@/lib/apps";

const Pulsynq = () => <AppShell app={getApp("pulsynq")} />;

export default Pulsynq;
